import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { REDESIGN_COLORS } from '../../styles/colors';

/**
 * SignalTagBadge — right-column tag for a single breakdown row.
 *
 * Visual treatment mirrors landing-v2 `SignalTagBadge` (text-only, uppercase,
 * bold, wide-tracked). Color is driven by the tag valence; informational tags
 * render with a muted alpha so facts don't compete with evaluative signals.
 *
 * @param {Object} props
 * @param {{ label: string, valence: 'positive'|'neutral'|'negative', informational?: boolean }} props.tag
 */
const SignalTagBadge = ({ tag }) => {
  if (!tag || !tag.label) return null;
  const { label, valence, informational } = tag;

  const palette = informational ? INFORMATIONAL_COLORS : EVALUATIVE_COLORS;
  const color = palette[valence] || palette.neutral;

  return (
    <Text style={[styles.text, { color }]}>{String(label).toUpperCase()}</Text>
  );
};

const EVALUATIVE_COLORS = {
  positive: REDESIGN_COLORS.scoreGood,
  neutral: 'rgba(255,255,255,0.85)',
  negative: REDESIGN_COLORS.scorePoor,
};

const INFORMATIONAL_COLORS = {
  positive: 'rgba(58,232,105,0.85)',
  neutral: 'rgba(255,255,255,0.65)',
  negative: 'rgba(255,123,0,0.95)',
};

const styles = StyleSheet.create({
  text: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 12,
    letterSpacing: 0.6,
    paddingLeft: 12,
    paddingVertical: 8,
  },
});

export default SignalTagBadge;
